import { GridColumnMenuCheckboxFilter, GridColumnMenuProps } from "@progress/kendo-react-grid";

export const RelationProjectStateColumnMenu = (props: GridColumnMenuProps) => (
  <GridColumnMenuCheckboxFilter
    expanded
    filterable
    data={[
      { ProjectState: "Sandbox" },
      { ProjectState: "Proposed" },
      { ProjectState: "Pending Launch" },
      { ProjectState: "Launched" },
      { ProjectState: "Interim Sandbox" },
      { ProjectState: "Interim Pending" },
      { ProjectState: "Interim Launched" },
      { ProjectState: "Launched Inactive" },
      { ProjectState: "Inbound Expired" },
    ]}
    searchBox={() => null}
    {...props}
  />
);
